module.exports = __webpack_public_path__ + "img/logo-login.74ac42e6.png";